import { Injectable } from "@angular/core";
import { ConstantsKey } from "app/shared/constant/constants-keys";
import { BaseProvider } from "app/shared/helper/http/BaseProvider";

@Injectable()
export class AddressService extends BaseProvider {

    getAddressList(){
        var resourceUrl = "consumers/address";
        return this.makeGetCall(resourceUrl);
    }

    createConsumerAddress(requestModel){
        var consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
        var resourceUrl = "consumers/" + consumerId +   "/address";
        return this.makePostCall(resourceUrl, requestModel);
    }

    updateConsumerAddress(requestModel, id){
        var resourceUrl = "consumers/address/" + id;
        return this.makePatchCall(resourceUrl, requestModel);
    }

    
    deleteConsumerAddress(addressID) {
        var resourceUrl = 'consumers/address/' + addressID;
        return this.makeDeleteCall(resourceUrl);
    }

    verifyPincode(pincode) {
        var resourceUrl = 'getCityByPincode?pincode='+ pincode;
        return this.makeGetCall(resourceUrl);
    }

    isDeliveryAvailbleByPincode(pincode) {
        var resourceUrl = 'pincodeFinder?pincode='+ pincode;
        return this.makePostCall(resourceUrl, {});
    }


    addXplorerCardAddress(requestModel) {
        var resourceUrl = 'xplorerCard/addCustomerAddress';
        return this.makePostCall(resourceUrl, requestModel);
    }    

    udpateXplorerCardAddress(requestModel, addressId) {
        var resourceUrl = 'xplorerCard/updateCustomerAddress?addressId='+addressId;
        return this.makePutCall(resourceUrl, requestModel);
    }        

    getXplorerCardAddress() {
        var resourceUrl = 'xplorerCard/fetchCustomerAddressDetails';
        return this.makeGetCall(resourceUrl);
    }

    deleteXplorerCardAddress(addressId: string) {
        var resourceUrl = 'xplorerCard/deleteCustomerAddress?addressId='+addressId;
        return this.makeDeleteCall(resourceUrl);
    }

    xplorerCardUpdateCustomerDetails(reqObj: any) {
        var resourceUrl = 'xplorerCard/updateCustomerDetails';
        return this.makePutCall(resourceUrl, reqObj);
    }





    


}